export const documentTypeQueryKeys = {
  all: ['document-types'] as const,
  list: () => ['document-types', 'list'] as const,
};
